<div class="page-not-found trp-flex--column">
	<div class="page-not-found__container trp-flex--column-center">
		<div class="page-not-found__message trp-flex--column-center">
			<trp-icon [name]="'frown'" [size]="'24px'"></trp-icon>
			<div class="trp__headline--main trp-m--t-02">Page not loading? We're on it.</div>
			<div class="trp-text__body page-not-found__inner-message">
				Sonething didn't go as planned. We're working to fix it. In the meantime, try
				refreshing the page.
			</div>
			<trp-button
				class="trp-m--t-03"
				[type]="buttonType.Primary"
				(buttonClicked)="redirectHome()"
				>Back home</trp-button
			>
		</div>
	</div>
</div>
